/**
 * @generated SignedSource<<8f080f22b1aabdb09a6837850ab32e5f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DirectoryTownPageQuery$variables = {
  areaSlug: string;
};
export type DirectoryTownPageQuery$data = {
  readonly landlordDirectoryArea: {
    readonly name: string | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"DirectoryTownAgentList_area" | "DirectoryTownFeeSummary_area" | "DirectoryTownSeoHead_area">;
  } | null | undefined;
};
export type DirectoryTownPageQuery = {
  response: DirectoryTownPageQuery$data;
  variables: DirectoryTownPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "areaSlug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "areaSlug"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DirectoryTownPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "LandlordDirectoryArea",
        "kind": "LinkedField",
        "name": "landlordDirectoryArea",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DirectoryTownSeoHead_area"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DirectoryTownFeeSummary_area"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DirectoryTownAgentList_area"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "DirectoryTownPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "LandlordDirectoryArea",
        "kind": "LinkedField",
        "name": "landlordDirectoryArea",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 100
              }
            ],
            "concreteType": "LandlordDirectoryAgentConnection",
            "kind": "LinkedField",
            "name": "agents",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "LandlordDirectoryAgentConnectionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LandlordDirectoryAgent",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "slug",
                        "storageKey": null
                      },
                      (v3/*:: as any*/),
                      (v2/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "address",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "googleMapsUrl",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "googleRating",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "googleReviewCount",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "trustpilotRating",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "trustpilotReviewCount",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LandlordDirectoryAgentFees",
                        "kind": "LinkedField",
                        "name": "fees",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "LandlordDirectoryAgentFee",
                            "kind": "LinkedField",
                            "name": "management",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "percent",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "sourceUrls",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "feesIncludeVat",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LandlordDirectoryAgentSources",
                        "kind": "LinkedField",
                        "name": "sources",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "trustpilot",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalCount",
                "storageKey": null
              }
            ],
            "storageKey": "agents(first:100)"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "LandlordDirectoryFeeStats",
            "kind": "LinkedField",
            "name": "feeStats",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sampleSize",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "minimumManagementFeePercent",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "medianManagementFeePercent",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "maximumManagementFeePercent",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v3/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3e4dfee584fa9c3a93e4aa504330e1c1",
    "id": null,
    "metadata": {},
    "name": "DirectoryTownPageQuery",
    "operationKind": "query",
    "text": "query DirectoryTownPageQuery(\n  $areaSlug: String!\n) {\n  landlordDirectoryArea(slug: $areaSlug) {\n    name\n    ...DirectoryTownSeoHead_area\n    ...DirectoryTownFeeSummary_area\n    ...DirectoryTownAgentList_area\n    id\n  }\n}\n\nfragment DirectoryTownAgentCard_agent on LandlordDirectoryAgent {\n  slug\n  name\n  address\n  googleMapsUrl\n  googleRating\n  googleReviewCount\n  trustpilotRating\n  trustpilotReviewCount\n  fees {\n    management {\n      percent\n      sourceUrls\n    }\n    feesIncludeVat\n  }\n  sources {\n    trustpilot\n  }\n}\n\nfragment DirectoryTownAgentList_area on LandlordDirectoryArea {\n  agents(first: 100) {\n    totalCount\n    edges {\n      node {\n        id\n        ...DirectoryTownAgentCard_agent\n      }\n    }\n  }\n}\n\nfragment DirectoryTownFeeSummary_area on LandlordDirectoryArea {\n  feeStats {\n    sampleSize\n    minimumManagementFeePercent\n    medianManagementFeePercent\n    maximumManagementFeePercent\n  }\n}\n\nfragment DirectoryTownSeoHead_area on LandlordDirectoryArea {\n  agents(first: 100) {\n    edges {\n      node {\n        slug\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "30b3c159bfb1094bca98d0d8e6dfa4ce";

export default node;
